/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
import 'leaflet/dist/leaflet.css';
import L, { FeatureGroup, LatLng, LatLngTuple, Polyline } from 'leaflet';
import 'src/libTypes/leaflet-minimap.d';
import 'src/libs/L.Donut';
import 'src/libs/L.CustomConic';
import 'src/libs/L.CustomSector';
import 'src/libs/leaflet.antimeridian-src';
import 'leaflet-arrowheads';
import 'leaflet.markercluster';
import 'src/libs/L.pattern-rectangle';

import { max } from 'lodash';
import distance from '@turf/distance';

import { CommandStatusLog, Hacim, Konum, TRectCoordinates } from 'src/types/mixed.type';
import { MapUnit, UnitType } from 'src/types/unit.type';
import {
  OverlappedClusterMarker,
  OverlappedUnitsClusterArgs,
  OverlappedUnitsPopupArgs,
  TSenseRangeProps,
  TSenseSensorCollection,
  TWeaponRangeProps,
  defaultVisualSettings,
  generalConfig,
  mapDefaultZoomLevel,
} from 'src/app/components/MapComponent/map.config';
import { TmkKalemiOzellikleriResultType } from 'src/types/services/hymotsc/tmk-kalemi-ozellikleri.type';
import { EEtmenTipi, EtmenDurumu } from 'src/types/components/socket.type';

import {
  isAirIcon,
  isShipIcon,
  prototypeIsSpace,
  unitIconGenerator,
  isUnitDetected,
} from 'src/app/helpers/units.helper';
import addMeter from 'src/app/utils/addMeter';
import { rotatePoints } from 'src/app/utils/mapUtil';
import { MapVisualSettings, TFilterType } from 'src/types/components/map.type';
import { MapViewState } from 'src/enums/map.enum';
import { OverlappedMarker } from 'src/app/components/MapComponent/OverlappedUnits/overlapped-units.config';
import { EAlgiDurumu, EFaaliyet, ESubFaaliyet } from 'src/enums/mixed.enum';
import { TaraflarArasiIliskiResultType } from 'src/types/services/hymotsc/taraflar-arasi-iliskiler.type';
import { userTypes } from 'src/types';
import { point } from '@turf/helpers';
import tinycolor from 'tinycolor2';
import { statusHelper } from 'src/app/helpers';
import { preloadMilsymbol } from 'src/app/helpers/milSymbol.helper';
import { MapController } from './MapController';
import { UnitsController } from './UnitsController';
import { createOrGetZone, TActiveUnitFilters, TEnvUnitsContainer, TMarkersContainer } from './config';

const displayAdditionalInfoThreshold = 8;

type ActionTypes = {
  onMapUnitClicked: (unitId: number, unitType: UnitType) => void;
  // onMarkerRightClickCommand: (commandType: CommandDomainType, commandId: number, unitId: number) => void;
  onMarkerViewInThreed: (id: number, lat: number, lng: number) => void;
  onMapZoom: (zoomLevel: number, coords: L.LatLng) => void;
  onMarketRightClickCancelExecutedCommand: (unitId: number) => void;
  onMapDrag: (coords: L.LatLng) => void;
  onMarkerRightClickEtmenTamamla: (unitId: number) => void;
};

export enum EMarkerDisplayMethod {
  DEFAULT,
  CLUSTER,
}

export const markerModes = {
  default: 0,
  cluster: 1,
};

export const areLocationsEqual = (srcKonum: Konum, targetKonum: Konum, ignoreAltitude = true) => {
  return (
    srcKonum.lat === targetKonum.lat &&
    srcKonum.lng === targetKonum.lng &&
    (ignoreAltitude || srcKonum.alt === targetKonum.alt)
  );
};

export const markerMode = generalConfig.agentsDisplayMethod;
export type TClusterBulkAddContainer = Record<number, { layers: L.Layer[]; rengi: string | undefined }>;

export const getDefaultPrevRoute = (rengi: string | undefined, isSatellite = false) => {
  if (isSatellite) {
    // @ts-ignore
    const route = new L.Wrapped.Polyline([[0, 0]], { color: rengi }).arrowheads({
      size: '10px',
      frequency: '240px',
    }) as L.Polyline;

    route.options.noClip = false;
    return route;
  }

  const route = L.polyline([[0, 0]], { color: rengi }).arrowheads({
    size: '10px',
    frequency: '240px',
  });
  route.options.noClip = false;
  return route;
};

export const getDefaultRemaRoute = (isSatellite = false) => {
  if (isSatellite) {
    // @ts-ignore
    const route = new L.Wrapped.Polyline([[0, 0]], { color: 'black' }).arrowheads({
      size: '10px',
      frequency: '240px',
    }) as L.Polyline;

    route.options.noClip = false;
    return route;
  }

  const route = L.polyline([[0, 0]], { color: 'black' }).arrowheads({
    size: '10px',
    frequency: '240px',
  });
  route.options.noClip = false;
  return route;
};

export class MapMarkerController extends MapController {
  unitsController: UnitsController;

  markers: TMarkersContainer = {};

  units: MapUnit[] = [];

  unitMarkersGroup = L.featureGroup();

  unitRoutesGroup = L.featureGroup();

  objectCounter: number = 0;

  focusedUnitId: number = -1;

  blockUpdateUnitId: number = -1;

  vectors: Polyline[] = [];

  actions: ActionTypes | undefined;

  iconsModeLabelled = false;

  rangeDonutGroup = L.featureGroup();

  rangeDonutCollection: { unitId: number; layerType: string; layer: L.Donut }[] = [];

  senseSectorGroup = L.featureGroup();

  senseSectorCollection: Record<number, TSenseSensorCollection> = {};

  identificationCircles = L.featureGroup();

  volumeRectangleGroup = L.featureGroup();

  volumeRectangleCollection: Record<number, L.Rectangle> = {};

  senseSelectedUnits: number[] = [];

  weaponRangeSelectedUnits: number[] = [];

  volumeSelectedUnits: number[] = [];

  sitrepSelectedUnits: number[] = [];

  missileAgentsDropPoints: Map<number | bigint, L.CircleMarker> = new Map();

  missileDropPoint = L.featureGroup();

  markersLeftClickStatus: boolean = true;

  firstLoad: boolean | undefined;

  mapVisualSettings: MapVisualSettings = defaultVisualSettings;

  activeFilters: TActiveUnitFilters = {
    sides: [],
    factions: [],
    prototypes: [],
  };

  unitToFollow: number | undefined;

  overlappedUnitsPopup?: (options: OverlappedUnitsPopupArgs) => void | undefined;

  userRole: userTypes.UserRoleType | undefined;

  environmentalEffectsContainer: TEnvUnitsContainer = {};

  environmentalEffectsGroup = L.featureGroup();

  connectionsCollection: Record<number, FeatureGroup> = {};

  connectionsGroup = L.featureGroup();

  circleId: number | undefined;

  measurements = L.featureGroup();

  measurementsList: Record<number, L.Polyline> = {};

  selectedMeasurementEntities: number[] = [];

  connectionsSelectedUnits: number[] = [];

  overlappedUnitsClusterPopup?: (options: OverlappedUnitsClusterArgs) => void | undefined;

  ownTarafId: number | undefined;

  sideRelations: TaraflarArasiIliskiResultType[] | undefined;

  controllingUnits: (number | bigint)[] | undefined;

  ports: L.Polygon[] = [];

  agentFilterOptions:
    | {
        ineffectiveAgents: boolean;
        landAgents: boolean;
        airAgents: boolean;
        maritimeAgents: boolean;
        spaceAgents: boolean;
      }
    | undefined = undefined;

  passiveFilters: { showPassiveAgents: boolean; showOnlyPassiveAgents: boolean } = {
    showPassiveAgents: false,
    showOnlyPassiveAgents: false,
  };

  // change this in the future

  clusters: Record<number, L.MarkerClusterGroup> = {};

  activeCommands: CommandStatusLog[] = [];

  gameId: number | undefined;

  firstLoadEnvUnits: boolean | undefined;

  mapZoom: number = mapDefaultZoomLevel;

  mapBounds: { northEast: Konum; southWest: Konum } | undefined;

  mapLastCenter: L.LatLng | undefined;

  createCluster = (rengi: string | undefined) => {
    const bgColor = tinycolor(rengi || 'rgb(255, 255, 128)');
    const textColor = bgColor.isDark() ? '#fff' : '#000';
    const bgHex = `#${bgColor.toHex()}`;
    const opacity = bgColor.isDark() ? 0.2 : 0.4;

    const cluster = L.markerClusterGroup({
      spiderfyOnMaxZoom: false,
      zoomToBoundsOnClick: false,
      polygonOptions: {
        color: bgHex,
        fillColor: bgHex,
        fillOpacity: opacity,
        opacity,
      },
      iconCreateFunction(clusterInFunction) {
        return new L.DivIcon({
          html: `<div style="background-color: ${bgHex};"><span class="marker-cluster-text" style="color: ${textColor}">${
            clusterInFunction.getAllChildMarkers().length
          }<span aria-label="markers"></span></span></div>`,
          className: 'marker-cluster marker-cluster-small',
          iconSize: new L.Point(40, 40),
        });
      },

      // elementsPlacementStrategy: 'concentric',
      // spiderfyDistanceSurplus: 50,
      // spiderfyDistanceMultiplier: 1.2,

      // elementsMultiplier: 2,
      // firstCircleElements: 7,
    });

    cluster.on('clusterclick', async (a) => {
      if (this.overlappedUnitsClusterPopup) {
        const children = a.layer.getAllChildMarkers() as L.Marker[];

        const localMarkers = await Promise.all(
          children
            .map(async (child) => {
              if (!child.options.unitId) return undefined;

              const item = this.markers[child.options.unitId];

              if (!item) return undefined;

              const { marker, unit } = item;
              const icon = await unitIconGenerator(unit, {
                additionalInfoBool: false,
                isForOverlappedPopup: true,
                relation: this.sideRelations?.find(
                  (sideRelation) =>
                    sideRelation.tarafKaynakId === this.ownTarafId && sideRelation.tarafHedefId === unit.taraf?.id,
                )?.deger,
                ignoreRelation: true,
              });

              if (!icon) return undefined;
              return {
                id: unit.id,
                icon,
                marker,
                unit,
              };
            })
            .filter((o) => o !== undefined),
        );

        this.overlappedUnitsClusterPopup({
          event: a as L.LeafletMouseEvent,
          markers: localMarkers as OverlappedClusterMarker[],
        });
      }
    });

    return cluster;
  };

  unitClusterAddHandler = (layer: L.Layer, unit: MapUnit, load: boolean = false) => {
    const tarafId = unit.taraf?.id || -2;
    if (!this.clusters[tarafId]) {
      const cluster = this.createCluster(unit.taraf?.rengi);

      this.clusters[unit.taraf?.id || -2] = cluster;

      this.map.addLayer(this.clusters[tarafId]);
    }

    if (load) {
      this.clusters[tarafId].addLayer(layer);
    } else if (!this.clusters[tarafId].hasLayer(layer)) {
      this.clusters[tarafId].addLayer(layer);
    }
  };

  unitChangeCluster = (layer: L.Layer, currentUnit: MapUnit, updatedUnit: MapUnit) => {
    this.unitRemoveHandler(layer, currentUnit, EMarkerDisplayMethod.CLUSTER);
    this.unitClusterAddHandler(layer, updatedUnit);
  };

  havaEtmeniBeklemeAlaniYaricapi: number | undefined;

  zoomLocationMarker = L.featureGroup();

  earthquakeCollection: Record<string, { markers: L.CircleMarker[]; isWithinOneHour: boolean; isActive: boolean }> = {};

  destroyedBuildingsCollection: Record<string, { markers: L.Marker[] }> = {};

  floodCollection: Record<
    string,
    {
      basePolygon: L.Polygon;
      currentPolygon1: L.Polygon;
      currentPolygon2: L.Polygon;
      currentPolygon3: L.Polygon;
      flowArrow: L.Polyline;
      [key: string]: any;
    }
  > = {};

  systems?: TmkKalemiOzellikleriResultType[];

  static instance: MapMarkerController | null = null;

  constructor(
    map: L.Map,
    isTheatre: boolean,
    mapViewState: MapViewState,
    unitsController: UnitsController,
    // userRole: string | undefined,
    actions?: ActionTypes,
  ) {
    super(map, mapViewState);
    this.unitsController = unitsController;

    this.map.addLayer(this.unitMarkersGroup);
    this.map.addLayer(this.unitRoutesGroup);
    this.map.addLayer(this.missileDropPoint);

    this.map.addLayer(this.rangeDonutGroup);
    this.map.addLayer(this.senseSectorGroup);
    this.map.addLayer(this.volumeRectangleGroup);
    this.map.addLayer(this.identificationCircles);

    this.firstLoad = true;

    if (actions) {
      this.actions = actions;
    }

    this.bindMarkersLeftClick();

    this.map.on('moveend', () => {
      const zoom = this.map.getZoom();
      const center = this.map.getCenter();
      this.actions?.onMapZoom(zoom, center);
      this.updateIconsOnZoom(zoom);

      this.updateIconsOnMoveend(zoom, this.map.getBounds());
    });

    this.map.on('dragend', () => {
      const center = this.map.getCenter();
      this.actions?.onMapDrag(center);
    });
  }

  clearUnitMarkers = () => {
    this.unitMarkersGroup.clearLayers();
    this.markers = {};
    this.firstLoad = undefined;
  };

  clearVectors = () => {
    this.vectors.forEach((vector) => {
      // @ts-ignore
      this.unitMovementVectorsGroup.removeLayer(vector);
    });

    this.vectors = [];
  };

  toggleMarker = (id: number) => {
    const marker = this.markers[id]?.marker;

    if (marker && !this.unitMarkersGroup.hasLayer(marker)) {
      this.unitMarkersGroup.addLayer(marker);
    }
  };

  updateIcons = () => {
    Object.values(this.markers).forEach(async ({ marker }) => {
      const unit = this.units.find((item) => item.id === marker.options.unitId);
      if (unit) {
        const icon = await unitIconGenerator(unit, {
          additionalInfoBool: false,
        });

        if (icon) {
          marker.setIcon(icon);
        }
      }
    });
  };

  updateIconsOnZoom = (zoomLevel: number) => {
    if (zoomLevel > 8 && !this.iconsModeLabelled) {
      Object.values(this.markers).forEach(async ({ marker }) => {
        const unit = this.units.find((item) => item.id === marker.options.unitId);
        if (unit) {
          const icon = await unitIconGenerator(unit, {
            additionalInfoBool: true,
          });

          if (icon) {
            marker.setIcon(icon);
          }
        }
      });

      this.iconsModeLabelled = true;
    } else if (zoomLevel <= 8 && this.iconsModeLabelled) {
      Object.values(this.markers).forEach(async ({ marker }) => {
        const unit = this.units.find((item) => item.id === marker.options.unitId);
        if (unit) {
          const icon = await unitIconGenerator(unit, {
            additionalInfoBool: false,
          });

          if (icon) {
            marker.setIcon(icon);
          }
        }
      });

      this.iconsModeLabelled = false;
    }
  };

  updateIconsOnMoveend = async (zoomLevel: number, boundingBox: L.LatLngBounds, overrideBoolean = false) => {
    if (zoomLevel > displayAdditionalInfoThreshold) {
      for (const { marker, unit, isLabelVisible } of Object.values(this.markers)) {
        if (
          (overrideBoolean || !isLabelVisible) &&
          unit &&
          isUnitDetected(unit.algiDurumu) &&
          boundingBox.contains(marker.getLatLng())
        ) {
          const icon = await unitIconGenerator(unit, {
            additionalInfoBool: true,
            // relation: this.sideRelations?.find(
            //   (o) => o.tarafKaynakId === this.ownTarafId && o.tarafHedefId === unit.taraf?.id,
            // )?.deger,
            ignoreRelation: true,
            mapVisualSettings: this.mapVisualSettings,
          });

          if (icon) {
            marker.setIcon(icon);
          }

          this.markers[unit.id] = {
            ...this.markers[unit.id],
            isLabelVisible: true,
          };
        }
      }
    } else if (zoomLevel <= displayAdditionalInfoThreshold) {
      for (const { marker, unit, isLabelVisible } of Object.values(this.markers)) {
        if (
          (overrideBoolean || isLabelVisible) &&
          unit &&
          isUnitDetected(unit.algiDurumu) &&
          boundingBox.contains(marker.getLatLng())
        ) {
          const icon = await unitIconGenerator(unit, {
            additionalInfoBool: false,
            // relation: this.sideRelations?.find(
            //   (o) => o.tarafKaynakId === this.ownTarafId && o.tarafHedefId === unit.taraf?.id,
            // )?.deger,
            ignoreRelation: true,
            mapVisualSettings: this.mapVisualSettings,
          });

          if (icon) {
            marker.setIcon(icon);
          }

          this.markers[unit.id] = {
            ...this.markers[unit.id],
            isLabelVisible: false,
          };
        }
      }
    }
  };

  // getCommandCallbacks = (sidc: string) => {
  //   // return CommandSubTypes.find((o) => o.domainId === CommandDomainType.Air)?.commands.map((o) => {
  //   //   return {
  //   //     text: o.label,
  //   //     callback: (e: any) => {
  //   //       this.actions?.onMarkerRightClickCommand(CommandDomainType.Air, o.id, e.relatedTarget.options.unitId);
  //   //     },
  //   //   };
  //   // });
  //   // switch (sidc.substring(4, 6)) {
  //   //   // case '01': // Air
  //   //   // case '02': // Air Missile
  //   //   case '10': // Land unit
  //   //   case '11': // Land Civilian Unit/Organization
  //   //   case '15': // Land Equipment
  //   //   case '20': // Land Insttallations
  //   //   case '25': // Control Measure
  //   //   case '27': // Dismounted Individual
  //   //     return CommandSubTypes.find((o: { domainId: any }) => o.domainId === CommandDomainType.Land)?.commands.map(
  //   //       (o: { label: any; id: number }) => {
  //   //         return {
  //   //           text: o.label,
  //   //           callback: (e: any) => {
  //   //             this.actions?.onMarkerRightClickCommand(CommandDomainType.Land, o.id, e.relatedTarget.options.unitId);
  //   //           },
  //   //         };
  //   //       },
  //   //     );
  //   //   case '30': // Sea Surface
  //   //   case '35': // Sea Subsurface
  //   //     return CommandSubTypes.find((o: { domainId: any }) => o.domainId === CommandDomainType.Maritime)?.commands.map(
  //   //       (o: { label: any; id: number }) => {
  //   //         return {
  //   //           text: o.label,
  //   //           callback: (e: any) => {
  //   //             this.actions?.onMarkerRightClickCommand(
  //   //               CommandDomainType.Maritime,
  //   //               o.id,
  //   //               e.relatedTarget.options.unitId,
  //   //             );
  //   //           },
  //   //         };
  //   //       },
  //   //     );
  //   //   default:
  //   //     return [];
  //   // }
  //   return [];
  // };

  clearRoutes = () => {
    this.unitRoutesGroup.clearLayers();
  };

  toggleRoutes = (id: number, bool: boolean) => {
    if (id !== -1 && this.markers[id]) {
      // this.unitRoutesGroup.clearLayers();
      const { previousRoute, remainingRoute, unitStandbyArea, reconnaisanceZones, patrolReconZone, capControlZone } =
        this.markers[id];

      if (previousRoute) {
        if (bool) {
          if (!this.unitRoutesGroup.hasLayer(previousRoute) && this.sitrepSelectedUnits.some((o) => o === id)) {
            this.unitRoutesGroup.addLayer(previousRoute);
          }
        } else {
          this.unitRoutesGroup.removeLayer(previousRoute);
        }
      }

      if (remainingRoute) {
        if (bool) {
          if (!this.unitRoutesGroup.hasLayer(remainingRoute) && this.sitrepSelectedUnits.some((o) => o === id)) {
            this.unitRoutesGroup.addLayer(remainingRoute);
          }
        } else {
          this.unitRoutesGroup.removeLayer(remainingRoute);
        }
      }
      if (unitStandbyArea) {
        if (bool) {
          if (!this.unitRoutesGroup.hasLayer(unitStandbyArea) && this.sitrepSelectedUnits.some((o) => o === id)) {
            this.unitRoutesGroup.addLayer(unitStandbyArea);
          }
        } else {
          this.unitRoutesGroup.removeLayer(unitStandbyArea);
        }
      }
      if (reconnaisanceZones) {
        if (bool) {
          if (!this.unitRoutesGroup.hasLayer(reconnaisanceZones) && this.sitrepSelectedUnits.some((o) => o === id)) {
            const marker = this.markers[id];
            const unit = marker?.unit;

            const locationForReconZone = unit.rota ? unit.rota.filter((o) => o.havaKesifBolgesiMi) : [];

            if (locationForReconZone.length > 1 && unit.etmenTipi === EEtmenTipi.HAVA) {
              const reconZoneIndexes = Math.floor(locationForReconZone.length / 4);
              const layerArr: L.Rectangle[] = [];

              for (let i = 0; i < reconZoneIndexes; i += 1) {
                const reconZoneLayer = createOrGetZone(reconnaisanceZones, `zone${i}`);
                if (reconZoneLayer) {
                  layerArr.push(reconZoneLayer);
                }
              }

              reconnaisanceZones.eachLayer((layer) => {
                const zoneLayer = layer as L.Rectangle;
                const found = layerArr.filter((o) => o.options.zoneId === zoneLayer.options.zoneId);
                if (found.length > 1) {
                  found.forEach((o) => {
                    if (o?.getBounds().getCenter() !== zoneLayer.getBounds().getCenter()) {
                      reconnaisanceZones.removeLayer(layer);
                    }
                  });
                }
                if (found.length === 0) {
                  reconnaisanceZones.removeLayer(layer);
                }
              });
            }
            this.unitRoutesGroup.addLayer(reconnaisanceZones);
            if (unit && unit.taraf?.rengi) this.patternHandler(unit.taraf?.rengi);
          }
        } else {
          this.unitRoutesGroup.removeLayer(reconnaisanceZones);
        }
      }
      if (patrolReconZone) {
        if (bool) {
          if (!this.unitRoutesGroup.hasLayer(patrolReconZone) && this.sitrepSelectedUnits.some((o) => o === id)) {
            const marker = this.markers[id];
            const unit = marker?.unit;

            if (unit && unit.rotaBolgeMi) {
              this.unitRoutesGroup.addLayer(patrolReconZone);
            }
          }
        } else {
          this.unitRoutesGroup.removeLayer(patrolReconZone);
        }
      }
      if (capControlZone) {
        if (bool) {
          if (!this.unitRoutesGroup.hasLayer(capControlZone) && this.sitrepSelectedUnits.some((o) => o === id)) {
            const marker = this.markers[id];
            const unit = marker?.unit;

            if (unit) {
              this.unitRoutesGroup.addLayer(capControlZone);
            }
          }
        } else {
          this.unitRoutesGroup.removeLayer(capControlZone);
        }
      }
    } else {
      // this.unitRoutesGroup.clearLayers();
    }
  };

  displayRange = (id: number, bool: boolean, rangeProps?: TWeaponRangeProps) => {
    if (bool) {
      const { unit } = this.markers[id];
      if (
        unit.algiDurumu > 0 &&
        rangeProps &&
        rangeProps.radius !== 1 &&
        unit &&
        rangeProps.radius >= rangeProps.innerRadius
      ) {
        try {
          const rangeDonut = new L.Donut(L.latLng(unit.konum.lat, unit.konum.lng), {
            ...rangeProps,
            color: 'red',
          });

          if (this.rangeDonutCollection.some((o) => o.unitId === id && o.layerType === 'sitrep')) {
            this.rangeDonutCollection = this.rangeDonutCollection.filter(
              (o) => o.unitId === id && o.layerType !== 'sitrep',
            );

            this.rangeDonutCollection.push({ unitId: id, layer: rangeDonut, layerType: 'sitrep' });
          } else {
            this.rangeDonutCollection.push({ unitId: id, layer: rangeDonut, layerType: 'sitrep' });
          }
          rangeDonut.addTo(this.rangeDonutGroup);
          // //@ts-ignore
          // const superEllipse = L.superEllipse(
          //   L.latLng(unit.konum.lat, unit.konum.lng),
          //   [unit.hacim.genislik + rangeProps.radius, unit.hacim.yukseklik + rangeProps.radius],
          //   unit.istikamet,
          //   4,
          //   {
          //     fillColor: '#FF8080',
          //     fillOpacity: 0.3,
          //     weight: 2,
          //   },
          // );
          // this.rangeDonutCollection[unit.id] = superEllipse;
          // superEllipse.addTo(this.rangeDonutGroup);
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      const layers = this.rangeDonutCollection;
      if (layers && layers.length > 0) {
        const foundLayer = layers.find((o) => o.unitId === id && o.layerType === 'sitrep');
        if (foundLayer) {
          this.rangeDonutGroup.removeLayer(foundLayer.layer);
          this.rangeDonutCollection = this.rangeDonutCollection.filter(
            (o) => o.unitId === id && o.layerType !== 'sitrep',
          );
        }
      }
    }
  };

  displaySense = (id: number, bool: boolean, rangeProps?: TSenseRangeProps) => {
    if (bool) {
      const { unit } = this.markers[id];

      if (rangeProps && unit && unit.algiDurumu > 0) {
        const identificationCircle = new L.Circle([unit.konum.lat, unit.konum.lng], {
          radius: rangeProps.identificationRadius,
          color: 'black',
          opacity: 0.8,
          fillColor: 'black',
        });

        const konikler: L.CustomSector[] = [];

        rangeProps.detectionAngle.forEach((konik) => {
          if (konik.innerRange > 0 || konik.range > 0) {
            const senseSector = new L.CustomConic(
              {
                innerRadius: konik.innerRange,
                radius: konik.range,
                angle: konik.angle,
                direction: unit.istikamet,
                location: [unit.konum.lat, unit.konum.lng],
              },
              {
                customStyle: {
                  color: 'green',
                  weight: 0,
                  opacity: 0,
                  fillColor: 'green',
                  fillOpacity: 1,
                },
              },
            );
            senseSector.addTo(this.senseSectorGroup);
            konikler.push(senseSector);
          }
        });

        this.senseSectorCollection[id] = { innerCircle: identificationCircle, konikler };
        identificationCircle.addTo(this.senseSectorGroup);
      }
    } else {
      const layer = this.senseSectorCollection[id];

      if (layer) {
        this.senseSectorGroup.removeLayer(layer.innerCircle);
        layer.konikler.forEach((eachLayer) => {
          this.senseSectorGroup.removeLayer(eachLayer);
        });
      }
      delete this.senseSectorCollection[id];
    }
  };

  displayVolume = (
    id: number,
    bool: boolean,
    volumeProps?: {
      volume: Hacim;
      center: Konum;
      bearing: number;
    },
  ) => {
    if (bool) {
      if (volumeProps) {
        const { genislik, uzunluk } = volumeProps.volume;
        const volumeRectangle = L.rectangle(
          [
            [0, 0],
            [0, 0],
          ],
          { color: 'red', weight: 2 },
        );
        this.setVolumeRectangle(volumeRectangle, volumeProps.center, volumeProps.bearing, genislik, uzunluk);

        this.volumeRectangleCollection[id] = volumeRectangle;
        volumeRectangle.addTo(this.volumeRectangleGroup);
      }
    } else {
      const layer = this.volumeRectangleCollection[id];
      if (layer) {
        this.volumeRectangleGroup.removeLayer(layer);
      }
      delete this.volumeRectangleCollection[id];
    }
  };

  onSitrepSelectUnit = (
    id: number,
    bool: boolean,
    rangeProps?: {
      range?: TWeaponRangeProps;
      sense?: TSenseRangeProps;
    },
    volumeProps?: {
      volume: Hacim;
      center: Konum;
      bearing: number;
    },
    measurement?: {
      locationInfo?: [];
    },
    isUnitWeaponRangeOpen?: boolean,
  ) => {
    if (bool) {
      if (!this.sitrepSelectedUnits.some((o) => o === id)) {
        this.sitrepSelectedUnits.push(id);
        const { unit, marker } = this.markers[id];

        if (unit.rota) this.toggleRoutes(id, unit && unit.rota.length > 1);

        if (markerMode === EMarkerDisplayMethod.CLUSTER && this.markers[id]) {
          this.markers[id].markerDisplayMethod = EMarkerDisplayMethod.DEFAULT;
          this.unitRemoveHandler(marker, unit, EMarkerDisplayMethod.CLUSTER);
          this.unitMarkersGroupAddHandler(marker, unit, EMarkerDisplayMethod.DEFAULT);
        }
      }

      if (rangeProps) {
        const { range, sense } = rangeProps;

        if (range) {
          // Do not draw again if already exists

          if (!this.rangeDonutCollection.some((o) => o.unitId === id && o.layerType === 'sitrep')) {
            if (!isUnitWeaponRangeOpen) {
              this.rangeDonutGroup.eachLayer((layer) => layer.remove());
            }

            this.displayRange(id, bool, range);
          }

          if (!this.weaponRangeSelectedUnits.find((o) => o === id)) {
            this.weaponRangeSelectedUnits.push(id);
          }
        } else if (!isUnitWeaponRangeOpen) {
          this.displayRange(id, false);
          this.weaponRangeSelectedUnits = this.weaponRangeSelectedUnits.filter((o) => o !== id);
        }
        if (sense) {
          // Do not draw again if already exists
          const existingLayer = this.senseSectorCollection[id];
          if (!existingLayer) {
            this.displaySense(id, bool, sense);
          }

          if (!this.senseSelectedUnits.find((o) => o === id)) {
            this.senseSelectedUnits.push(id);
          }
          if (existingLayer && this.senseSelectedUnits.find((o) => o === id)) {
            this.displaySense(id, false);
            this.senseSelectedUnits = this.senseSelectedUnits.filter((o) => o !== id);
            delete this.senseSectorCollection[id];
          }
        } else {
          this.displaySense(id, false);
          this.senseSelectedUnits = this.senseSelectedUnits.filter((o) => o !== id);
        }
      } else {
        if (!isUnitWeaponRangeOpen) {
          this.displayRange(id, false);
          this.weaponRangeSelectedUnits = this.weaponRangeSelectedUnits.filter((o) => o !== id);
        }

        this.displaySense(id, false);

        this.senseSelectedUnits = this.senseSelectedUnits.filter((o) => o !== id);
      }

      if (volumeProps) {
        // Do not draw again if already exists
        // if (!this.volumeRectangleCollection[id]) {
        //   this.displayVolume(id, bool, volumeProps);
        // }

        // Delete and replace for volume changing
        const existVolume = this.volumeRectangleCollection[id];

        if (existVolume) {
          this.volumeRectangleGroup.removeLayer(existVolume);
        }

        this.displayVolume(id, bool, volumeProps);

        if (!this.volumeSelectedUnits.find((o) => o === id)) {
          this.volumeSelectedUnits.push(id);
        }
      } else {
        this.displayVolume(id, false);

        this.volumeSelectedUnits = this.volumeSelectedUnits.filter((o) => o !== id);
      }
    } else {
      this.sitrepSelectedUnits = this.sitrepSelectedUnits.filter((o) => o !== id);
      this.toggleRoutes(id, false);

      if (markerMode === EMarkerDisplayMethod.CLUSTER && this.markers[id]) {
        const { unit, marker } = this.markers[id];
        this.markers[id].markerDisplayMethod = EMarkerDisplayMethod.CLUSTER;
        this.unitRemoveHandler(marker, unit, EMarkerDisplayMethod.DEFAULT);
        this.unitMarkersGroupAddHandler(marker, unit, EMarkerDisplayMethod.CLUSTER);
      }

      this.displayRange(id, false);

      /*       if (!isUnitWeaponRangeOpen) {
        this.rangeDonutGroup.eachLayer((layer) => layer.remove());
      } */

      this.weaponRangeSelectedUnits = this.weaponRangeSelectedUnits.filter((o) => o !== id);

      this.displaySense(id, false);
      this.displayVolume(id, false);
      // this.displayMeasurements(id, false);

      this.senseSelectedUnits = this.senseSelectedUnits.filter((o) => o !== id);
      this.volumeSelectedUnits = this.volumeSelectedUnits.filter((o) => o !== id);
      // this.selectedMeasurementEntities = this.selectedMeasurementEntities.filter((o) => o !== id);
    }
  };

  setVolumeRectangle = (rectangle: L.Rectangle, center: Konum, bearing: number, genislik: number, uzunluk: number) => {
    const customGenislik = genislik * 1;
    const customUzunluk = uzunluk * 1;

    const NEPoint = addMeter(center, customUzunluk / 2, customGenislik / 2);
    const SEPoint = addMeter(center, (customUzunluk / 2) * -1, customGenislik / 2);

    const SWPoint = addMeter(center, (customUzunluk / 2) * -1, (customGenislik / 2) * -1);
    const NWPoint = addMeter(center, customUzunluk / 2, (customGenislik / 2) * -1);

    const rotatedPoints = rotatePoints(
      this.map,
      center as L.LatLng,
      [SWPoint as L.LatLng, SEPoint as L.LatLng, NEPoint as L.LatLng, NWPoint as L.LatLng],
      bearing,
    );

    rectangle.setLatLngs(rotatedPoints);
  };

  deleteUnits = (ids: (number | bigint)[]) => {
    ids.forEach((id) => {
      if (this.markers[id as number]) {
        const { unit } = this.markers[id as number];

        if (unit) {
          try {
            const {
              marker,
              previousRoute,
              remainingRoute,
              markerDisplayMethod,
              unitStandbyArea,
              reconnaisanceZones,
              patrolReconZone,
              capControlZone,
            } = this.markers[id as number];

            if (marker) {
              this.unitRemoveHandler(marker, unit, markerDisplayMethod);
              this.unitRoutesGroup.removeLayer(previousRoute);
              this.unitRoutesGroup.removeLayer(remainingRoute);
              this.unitRoutesGroup.removeLayer(unitStandbyArea);
              this.unitRoutesGroup.removeLayer(reconnaisanceZones);
              this.unitRoutesGroup.removeLayer(patrolReconZone);
              this.unitRoutesGroup.removeLayer(capControlZone);
              delete this.markers[id as number];
            }
          } catch (error) {
            statusHelper.displayErrorMessage('Unexpected Error While Removing Agent');
          }
        }
      }
    });
  };

  unitRemoveHandler = (layer: L.Layer, unit: MapUnit, markerDisplayMethod: EMarkerDisplayMethod) => {
    switch (markerDisplayMethod) {
      case EMarkerDisplayMethod.CLUSTER:
        break;
      default:
        this.unitMarkersGroup.removeLayer(layer);
        break;
    }
  };

  unitMarkersGroupAddHandler = (
    layer: L.Layer,
    unit: MapUnit,
    markerDisplayMethod: EMarkerDisplayMethod,
    load: boolean = false,
  ) => {
    switch (markerDisplayMethod) {
      case EMarkerDisplayMethod.CLUSTER:
        // this.unitClusterAddHandler(layer, unit, load);
        break;
      default:
        // if (this.unitMarkersGroup.getLayers().length <= this.mapVisualSettings.maxVisibleAgents) {
        if (load) {
          this.unitMarkersGroup.addLayer(layer);
        } else if (!this.unitMarkersGroup.hasLayer(layer)) {
          this.unitMarkersGroup.addLayer(layer);
        }
        // }
        break;
    }
  };

  clearMissileDropPointsOnMarkersDelete = (unitId: number | bigint) => {
    const foundMissileUnit = this.missileAgentsDropPoints.get(unitId);
    if (foundMissileUnit) {
      this.missileDropPoint.removeLayer(foundMissileUnit);
      this.missileAgentsDropPoints.delete(unitId);
    }
  };

  loadUnits = (units: MapUnit[]) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const unit of units) {
      this.loadUnit(unit, markerMode === markerModes.cluster);
    }

    // if (markerMode === markerModes.cluster) {
    //   this.unitClusterBulkAddHandler(markersContainer);
    // }
  };

  findMaxDistanceGenerator = (konumArray: Konum[], firstKonum: Konum | undefined) => {
    let furthestLocation: Konum | undefined;
    let calculatedDistance: number = 0;

    if (konumArray && konumArray.length > 0 && firstKonum) {
      konumArray.forEach((konum) => {
        let maxDistance = calculatedDistance;
        const from = point([firstKonum.lat, firstKonum.lng]);
        const to = point([konum.lat, konum.lng]);
        calculatedDistance = distance(from, to);

        if (maxDistance < calculatedDistance) {
          maxDistance = calculatedDistance;
          furthestLocation = konum;
        }
      });
    }
    return furthestLocation;
  };

  loadUnit = async (unit: MapUnit, isLoadUnits = false) => {
    await preloadMilsymbol();

    if (this.markers[unit.id]) {
      this.updateUnit(unit.id, unit);
      return;
    }

    const { id, unitType } = unit;

    const icon = await unitIconGenerator(unit, {
      additionalInfoBool: this.map.getZoom() > displayAdditionalInfoThreshold,
      // relation: this.sideRelations?.find(
      //   (o) => o.tarafKaynakId === this.ownTarafId && o.tarafHedefId === unit.taraf?.id,
      // )?.deger,
      // ignoreRelation: this.userRole !== 'Player',
      mapVisualSettings: this.mapVisualSettings,
    });

    if (!icon) {
      // eslint-disable-next-line no-console
      console.error('UNIT CREATE ERROR', unit);
      return;
    }

    const marker = L.marker(unit.konum, {
      icon,
      unitId: id,
      unitType,
      markerZoom: this.map.getZoom(),
      riseOnHover: true,
    });

    let previousRoute = getDefaultPrevRoute(unit.taraf?.rengi, prototypeIsSpace(unit.etmenTuru?.sembolu));
    let remainingRoute = getDefaultRemaRoute(prototypeIsSpace(unit.etmenTuru?.sembolu));

    let patrolReconZone = L.featureGroup();
    let unitStandbyArea = L.featureGroup();
    let reconnaisanceZones = L.featureGroup();
    let capControlZone = L.featureGroup();

    const markerDisplayMethod =
      markerMode === markerModes.cluster ? EMarkerDisplayMethod.CLUSTER : EMarkerDisplayMethod.DEFAULT;

    const zoomLevel = this.map.getZoom();

    if (unit.rota && unit.rota.length > 0) {
      const faaliyetDurumuBeklemedeMi = unit.faaliyeti === EFaaliyet.BEKLEMEDE;
      const harekatSafhasiYakitIkmalMi =
        unit.harekatSafhasi === ESubFaaliyet['AIR WAITING FUEL SUPPLY'] ||
        unit.harekatSafhasi === ESubFaaliyet['AIR AWACS EXECUTION'];

      const isAddCircleToBreakPoints = faaliyetDurumuBeklemedeMi || harekatSafhasiYakitIkmalMi;

      const foundKonum = unit.rota.find((o) => o.siralama === unit.rotaSirasi || 0 + 1);

      if (unit.rotaBolgeMi) {
        const location0 = unit.rota[0];
        const location1 = unit.rota[1];

        if (location0 && location1) {
          const northEastLocation = new LatLng(location1?.konum?.lat, location0?.konum?.lng);
          const southWestLocation = new LatLng(location0?.konum?.lat, location1?.konum?.lng);

          const reconAreaBounds = new L.LatLngBounds(southWestLocation, northEastLocation);

          const patrolZoneLayers = patrolReconZone.getLayers() as L.Rectangle[];
          const foundLayer = patrolZoneLayers.find((u) => u.options.unitId === id);

          if (!foundLayer) {
            const rectangle = new L.Rectangle(
              [
                [0, 0],
                [0, 0],
              ],
              {
                // @ts-ignore
                unitId: id,
              },
            );
            rectangle.setBounds(reconAreaBounds);
            patrolReconZone.addLayer(rectangle);
            patrolReconZone.getLayers().forEach((layer) => {
              if (layer instanceof L.Rectangle) {
                layer.redraw();
              }
            });
          } else {
            foundLayer.setBounds(reconAreaBounds);
          }

          this.unitRoutesGroup.removeLayer(previousRoute);
          this.unitRoutesGroup.removeLayer(remainingRoute);
        }
      } else {
        this.unitRoutesGroup.removeLayer(patrolReconZone);
        patrolReconZone = L.featureGroup();
      }

      // Update Prev Route
      if (previousRoute && !unit.rotaBolgeMi) {
        if (unit.rota.length > 1) {
          if (isAddCircleToBreakPoints) {
            const circle = new L.Circle([0, 0], {
              radius: 0,
              color: unit.taraf?.rengi,
              opacity: 0.8,
              fillColor: unit.taraf?.rengi,
              unitId: id,
            });
            if (this.havaEtmeniBeklemeAlaniYaricapi) circle.setRadius(this.havaEtmeniBeklemeAlaniYaricapi);
            circle.setLatLng([foundKonum?.konum.lat || unit.konum.lat, foundKonum?.konum.lng || unit.konum.lng]);
            const circleLayers = unitStandbyArea.getLayers() as L.Circle[];
            const isLayerExist = circleLayers.find((o) => o.options.unitId === id);
            if (!isLayerExist) unitStandbyArea.addLayer(circle);
          } else if (unitStandbyArea) {
            this.unitRoutesGroup.removeLayer(unitStandbyArea);
            unitStandbyArea = L.featureGroup();
          }

          const locationForReconZone = unit.rota.filter((o) => o.havaKesifBolgesiMi);
          try {
            if (locationForReconZone.length > 1 && unit.etmenTipi === EEtmenTipi.HAVA) {
              const reconZoneIndexes = Math.floor(locationForReconZone.length / 4);

              for (let i = 0; i < reconZoneIndexes; i += 1) {
                const reconZoneLayer = createOrGetZone(reconnaisanceZones, `zone${i}`);
                //  const northEastIndexConvertion = reconZoneIndexes % 2 === 0 ? 2 : 3;

                const location0 = locationForReconZone[i * 4];

                const extractedKonumArray = locationForReconZone.slice(i * 4, i * 4 + 4);

                const location1 = this.findMaxDistanceGenerator(
                  extractedKonumArray.map((o) => o.konum),
                  location0.konum,
                );

                if (location0 && location1) {
                  const northEastLocation = new LatLng(location1?.lat, location0?.konum?.lng);
                  const southWestLocation = new LatLng(location0?.konum?.lat, location1?.lng);

                  const reconAreaBounds = new L.LatLngBounds(southWestLocation, northEastLocation);

                  reconZoneLayer.setBounds(reconAreaBounds);
                }
              }
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to set recon zone error:', error);
          }

          let prevPoints: number[][] | number[][][] = [];

          if (locationForReconZone && locationForReconZone.length > 0 && unit.etmenTipi === EEtmenTipi.HAVA) {
            const polylineArray = [];
            let firstIndex = 0;
            for (let i = 0; i < locationForReconZone.length / 4; i += 1) {
              const currentIndex = firstIndex;

              polylineArray.push(
                unit.rota.filter(
                  (o) => o.siralama >= currentIndex && o.siralama <= locationForReconZone[i * 4].siralama,
                ),
              );

              if (i === locationForReconZone.length / 4 - 1) {
                polylineArray.push(
                  unit.rota.filter(
                    (o) => o.siralama >= currentIndex && o.siralama >= locationForReconZone[i * 4 + 3].siralama,
                  ),
                );
              }

              firstIndex = locationForReconZone[i * 4 + 3].siralama;
            }
            const updatedPolylineArray = polylineArray.map((o) => {
              const updatedPolyine = [
                ...o.filter((u) => u.siralama <= unit.rotaSirasi).map((t) => [t.konum.lat, t.konum.lng]),
              ];

              if (unit.rotaSirasi >= o[0].siralama && unit.rotaSirasi < o[o.length - 1].siralama) {
                updatedPolyine.push([unit.konum.lat, unit.konum.lng]);
              }

              return updatedPolyine;
            });

            prevPoints = updatedPolylineArray;
          } else {
            const foundLayer = (unitStandbyArea.getLayers() as L.Circle[]).find((o) => o.options.unitId === id);
            prevPoints = [
              ...unit.rota.filter((o) => o.siralama <= unit.rotaSirasi).map((o) => [o.konum.lat, o.konum.lng]),
              ...[
                isAddCircleToBreakPoints
                  ? foundLayer
                    ? [foundLayer?.getLatLng()?.lat, foundLayer?.getLatLng()?.lng]
                    : [unit.konum.lat, unit.konum.lng]
                  : [unit.konum.lat, unit.konum.lng],
              ],
            ];
          }

          previousRoute.setLatLngs(prevPoints as LatLngTuple[]);
          previousRoute.redraw();
          if (unit.etmenTipi === EEtmenTipi.HAVA) {
            unitStandbyArea.getLayers().forEach((layer) => {
              if (layer instanceof L.Circle) {
                layer.redraw();
              }
            });
            reconnaisanceZones.eachLayer((layer) => {
              if (layer instanceof L.Rectangle) {
                layer.redraw();
              }
            });
          }
        } else {
          this.unitRoutesGroup.removeLayer(previousRoute);
          this.unitRoutesGroup.removeLayer(unitStandbyArea);

          previousRoute = getDefaultPrevRoute(unit.taraf?.rengi);
          unitStandbyArea = L.featureGroup();
          this.unitRoutesGroup.removeLayer(reconnaisanceZones);
          reconnaisanceZones = L.featureGroup();
        }
      }

      if (unit.kontrolBolgesi && unit?.kontrolBolgesi.length > 0) {
        const locations: LatLngTuple[] = unit.kontrolBolgesi.map((o) => {
          return [o.lat, o.lng];
        });

        const controlZoneLayers = capControlZone.getLayers() as L.Polygon[];
        const foundLayer = controlZoneLayers.find((u) => u.options.unitId === id);

        if (!foundLayer) {
          const controlZonePolygon = L.polygon(locations, {
            color: unit.taraf?.rengi || 'lightblue',
            fillColor: unit.taraf?.rengi || 'lightblue',
            fillOpacity: 0.2,
            unitId: id,
          });

          capControlZone.addLayer(controlZonePolygon);

          capControlZone.getLayers().forEach((layer) => {
            if (layer instanceof L.Polygon) {
              layer.redraw();
            }
          });
        } else {
          foundLayer.setLatLngs(locations);
        }
      }

      // Update Rema Route
      if (remainingRoute && !unit.rotaBolgeMi) {
        if (unit.rota.length > 1) {
          if (isAddCircleToBreakPoints) {
            const circle = new L.Circle([0, 0], {
              radius: 0,
              color: unit.taraf?.rengi,
              opacity: 0.8,
              fillColor: unit.taraf?.rengi,
              unitId: id,
            });
            if (this.havaEtmeniBeklemeAlaniYaricapi) circle.setRadius(this.havaEtmeniBeklemeAlaniYaricapi);
            circle.setLatLng([foundKonum?.konum.lat || unit.konum.lat, foundKonum?.konum.lng || unit.konum.lng]);
            const circleLayers = unitStandbyArea.getLayers() as L.Circle[];
            const isLayerExist = circleLayers.find((o) => o.options.unitId === id);
            if (!isLayerExist) unitStandbyArea.addLayer(circle);
          }

          const locationForReconZone = unit.rota.filter((o) => o.havaKesifBolgesiMi);

          try {
            if (locationForReconZone.length > 1 && unit.etmenTipi === EEtmenTipi.HAVA) {
              const reconZoneIndexes = Math.floor(locationForReconZone.length / 4);

              for (let i = 0; i < reconZoneIndexes; i += 1) {
                const reconZoneLayer = createOrGetZone(reconnaisanceZones, `zone${i}`);
                //  const northEastIndexConvertion = reconZoneIndexes % 2 === 0 ? 2 : 3;

                const location0 = locationForReconZone[i * 4];

                const extractedKonumArray = locationForReconZone.slice(i * 4, i * 4 + 4);

                const location1 = this.findMaxDistanceGenerator(
                  extractedKonumArray.map((o) => o.konum),
                  location0.konum,
                );

                if (location0 && location1) {
                  const northEastLocation = new LatLng(location1?.lat, location0?.konum?.lng);
                  const southWestLocation = new LatLng(location0?.konum?.lat, location1?.lng);

                  const reconAreaBounds = new L.LatLngBounds(southWestLocation, northEastLocation);

                  reconZoneLayer.setBounds(reconAreaBounds);
                }
              }
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to set recon zone error:', error);
          }

          let remaPoints: number[][] | number[][][] = [];

          if (locationForReconZone && locationForReconZone.length > 0 && unit.etmenTipi === EEtmenTipi.HAVA) {
            const polylineArray = [];
            let firstIndex = 0;
            for (let i = 0; i < locationForReconZone.length / 4; i += 1) {
              const currentIndex = firstIndex;

              polylineArray.push(
                unit.rota.filter(
                  (o) => o.siralama >= currentIndex && o.siralama <= locationForReconZone[i * 4].siralama,
                ),
              );

              if (i === locationForReconZone.length / 4 - 1) {
                polylineArray.push(
                  unit.rota.filter(
                    (o) => o.siralama >= currentIndex && o.siralama >= locationForReconZone[i * 4 + 3].siralama,
                  ),
                );
              }

              firstIndex = locationForReconZone[i * 4 + 3].siralama;
            }

            const updatedPolylineArray = polylineArray.map((o) => {
              const updatedPolyine = [
                ...o.filter((u) => u.siralama > unit.rotaSirasi).map((t) => [t.konum.lat, t.konum.lng]),
              ];

              if (unit.rotaSirasi >= o[0].siralama && unit.rotaSirasi <= o[o.length - 1].siralama) {
                updatedPolyine.unshift([unit.konum.lat, unit.konum.lng]);
                return updatedPolyine;
              }

              const filteredPolylines = o
                .filter((u) => u.siralama >= unit.rotaSirasi)
                .map((t) => [t.konum.lat, t.konum.lng]);
              return filteredPolylines;
            });

            remaPoints = updatedPolylineArray;
          } else {
            const foundLayer = (unitStandbyArea.getLayers() as L.Circle[]).find((o) => o.options.unitId === id);

            remaPoints = [
              ...[
                isAddCircleToBreakPoints
                  ? foundLayer
                    ? [foundLayer?.getLatLng()?.lat, foundLayer?.getLatLng()?.lng]
                    : [unit.konum.lat, unit.konum.lng]
                  : [unit.konum.lat, unit.konum.lng],
              ],
              ...unit.rota.filter((o) => o.siralama > unit.rotaSirasi).map((o) => [o.konum.lat, o.konum.lng]),
            ];
          }

          remainingRoute.setLatLngs(remaPoints as LatLngTuple[]);
          remainingRoute.redraw();
          if (unit.etmenTipi === EEtmenTipi.HAVA) {
            unitStandbyArea.getLayers().forEach((layer) => {
              if (layer instanceof L.Circle) layer.redraw();
            });
            reconnaisanceZones.eachLayer((layer) => {
              if (layer instanceof L.Rectangle) {
                layer.redraw();
              }
            });
          }
        } else {
          this.unitRoutesGroup.removeLayer(remainingRoute);
          if (unitStandbyArea) this.unitRoutesGroup.removeLayer(unitStandbyArea);
          unitStandbyArea = L.featureGroup();
          remainingRoute = getDefaultRemaRoute();
          this.unitRoutesGroup.removeLayer(reconnaisanceZones);
          reconnaisanceZones = L.featureGroup();
        }
      }
      if (unit?.kontrolBolgesi && unit?.kontrolBolgesi.length > 0) {
        const locations: LatLngTuple[] = unit.kontrolBolgesi.map((o) => {
          return [o.lat, o.lng];
        });

        const controlZoneLayers = capControlZone.getLayers() as L.Polygon[];
        const foundLayer = controlZoneLayers.find((u) => u.options.unitId === id);

        if (!foundLayer) {
          const controlZonePolygon = L.polygon(locations, {
            color: unit.taraf?.rengi || 'lightblue',
            fillColor: unit.taraf?.rengi || 'lightblue',
            fillOpacity: 0.2,
            unitId: id,
          });

          capControlZone.addLayer(controlZonePolygon);

          capControlZone.getLayers().forEach((layer) => {
            if (layer instanceof L.Polygon) {
              layer.redraw();
            }
          });
        } else {
          foundLayer.setLatLngs(locations);
        }

        this.unitRoutesGroup.removeLayer(previousRoute);
        this.unitRoutesGroup.removeLayer(remainingRoute);
      } else {
        this.unitRoutesGroup.removeLayer(capControlZone);
        capControlZone = L.featureGroup();
      }
    }

    this.markers[unit.id] = {
      unit,
      marker,
      previousRoute,
      remainingRoute,
      isLabelVisible: zoomLevel > displayAdditionalInfoThreshold,
      markerDisplayMethod,
      unitStandbyArea,
      reconnaisanceZones,
      patrolReconZone,
      capControlZone,
    };

    if (unit.isActive && unit.algiDurumu > 0 && unit.etmenAktiflikDurumu !== EtmenDurumu.PASIF) {
      if (!isLoadUnits) {
        this.unitMarkersGroupAddHandler(marker, unit, markerDisplayMethod, true);
      }
    }
  };

  zoomToUnit = (unitId: number) => {
    const zoomLevel = 12;
    const targetZoomLevel = max([this.map.getZoom(), zoomLevel]) || zoomLevel;
    const entry = this.markers[unitId];

    if (entry) {
      const markerToZoom = entry.marker;

      if (markerToZoom) {
        this.map.setView(markerToZoom.getLatLng(), targetZoomLevel, {
          animate: true,
          duration: 0.5,
        });
      }
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, class-methods-use-this
  highlightMarker = (_toggle: boolean = true) => {};

  isUnitOverlap = (unitId: number) => {
    const overlappedArray: MapUnit[] = [];
    const clickedUnitMarkerRect = document.getElementsByClassName(`unit-icon-${unitId}`)[0]?.getBoundingClientRect();

    Object.values(this.markers)
      .map(({ unit }) => unit)
      .filter((u) => u.algiDurumu > 0)
      .forEach((o) => {
        const unitRect = document.getElementsByClassName(`unit-icon-${o.id}`)[0]?.getBoundingClientRect();
        if (unitRect) {
          // Overlap logic without additional infos
          if (this.map.getZoom() < displayAdditionalInfoThreshold) {
            if (
              Math.abs(clickedUnitMarkerRect.left - unitRect.left) <= 12 &&
              Math.abs(clickedUnitMarkerRect.top - unitRect.top) <= 12
            ) {
              overlappedArray.push(o);
            }
          }
          // Overlap logic with additional infos
          else {
            const isShip = isShipIcon(o.etmenTuru?.sidc || '');
            const isAircraft = isAirIcon(o.etmenTuru?.sidc || '');

            const newClickedUnitMarkerRect: TRectCoordinates =
              isShip || isAircraft
                ? {
                    top: clickedUnitMarkerRect.top - 9,
                    bottom: clickedUnitMarkerRect.bottom - 9,
                    left: clickedUnitMarkerRect.left,
                    right: clickedUnitMarkerRect.right - 94,
                  }
                : {
                    top: clickedUnitMarkerRect.top,
                    bottom: clickedUnitMarkerRect.bottom,
                    left: clickedUnitMarkerRect.left - 94,
                    right: clickedUnitMarkerRect.right,
                  };

            const newCoords: TRectCoordinates = isShip
              ? {
                  top: unitRect.top - 9,
                  bottom: unitRect.bottom - 9,
                  left: unitRect.left,
                  right: unitRect.right - 94,
                }
              : {
                  top: unitRect.top,
                  bottom: unitRect.bottom,
                  left: unitRect.left - 94,
                  right: unitRect.right,
                };

            if (
              Math.abs(newClickedUnitMarkerRect.left - newCoords.left) <= 95 &&
              Math.abs(newClickedUnitMarkerRect.top - newCoords.top) <= 10
            ) {
              overlappedArray.push(o);
            }
          }
        }
      });

    return overlappedArray;
  };

  updateUnits = (units: MapUnit[]) => {
    units?.forEach((unit) => {
      if (unit) {
        this.updateUnit(unit.id, unit);
      }
    });
  };

  createSVGPattern = (color: string) => {
    return `
      <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
            <line x1="0" y1="5" x2="100" y2="5" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="10" x2="100" y2="10" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="15" x2="100" y2="15" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="20" x2="100" y2="20" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="25" x2="100" y2="25" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="30" x2="100" y2="30" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="35" x2="100" y2="35" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="40" x2="100" y2="40" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="45" x2="100" y2="45" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="50" x2="100" y2="50" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="55" x2="100" y2="55" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="60" x2="100" y2="60" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="65" x2="100" y2="65" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="70" x2="100" y2="70" class="line" stroke="${color}" stroke-width="2" />
      <line x1="0" y1="75" x2="100" y2="75" class="line" stroke="${color}" stroke-width="2" />
      </svg>
    `;
  };

  patternHandler = (color: string) => {
    const svgString = this.createSVGPattern(color);
    const url = `data:image/svg+xml;base64,${btoa(svgString)}`;

    const element = document.createElement('img');
    element.id = 'pattern';
    element.src = url;
    element.hidden = true;
    document.body.appendChild(element);
  };

  removePatternHandler = () => {
    const foundElement = document.getElementById('pattern');
    if (foundElement) document.body.removeChild(foundElement);
  };

  updateUnit = async (id: number, unit: MapUnit) => {
    const selectedMarker = this.markers[id];

    const localUnit = selectedMarker?.unit;
    const marker = selectedMarker?.marker;
    const markerDisplayMethod = selectedMarker?.markerDisplayMethod;

    let previousRoute = selectedMarker?.previousRoute;
    let remainingRoute = selectedMarker?.remainingRoute;
    let unitStandbyArea = selectedMarker?.unitStandbyArea;
    let reconnaisanceZones = selectedMarker?.reconnaisanceZones;
    let patrolReconZone = selectedMarker?.patrolReconZone;
    let capControlZone = selectedMarker?.capControlZone;

    const markerUnit = { ...localUnit };

    const isUnitAllowed = this.isUnitAllowedThroughFilter(unit);

    if (marker && markerUnit) {
      const shouldIconUpdate = !(
        markerUnit.algiDurumu === unit.algiDurumu &&
        markerUnit.istikamet === unit.istikamet &&
        markerUnit.hiz === unit.hiz &&
        markerUnit.insanZayiatOrani === unit.insanZayiatOrani &&
        markerUnit.otonomZayiatOrani === unit.otonomZayiatOrani &&
        markerUnit.faaliyeti === unit.faaliyeti &&
        markerUnit.etmenTuru?.id === unit.etmenTuru?.id &&
        markerUnit.etmenAktiflikDurumu === unit.etmenAktiflikDurumu
      );

      const shouldTarafClusterUpdate =
        markerUnit.taraf?.id !== unit.taraf?.id && markerDisplayMethod === EMarkerDisplayMethod.CLUSTER;

      const shouldKonumUpdate = !areLocationsEqual(markerUnit.konum, unit.konum);

      const isWeaponRangeSelected = this.weaponRangeSelectedUnits.find((o) => o === markerUnit.id);

      const isSenseRangeSelected = this.senseSelectedUnits.find((o) => o === markerUnit.id);

      const isVolumeSitrepSelected = this.volumeSelectedUnits.find((o) => o === markerUnit.id);

      const shouldRotaBolgemiUpdate = markerUnit.rotaBolgeMi !== unit.rotaBolgeMi;

      if (shouldTarafClusterUpdate) {
        this.unitChangeCluster(marker, markerUnit, unit);
      }

      markerUnit.konum = L.latLng(unit.konum);
      markerUnit.rota = unit.rota;
      markerUnit.rotaSirasi = unit.rotaSirasi;
      markerUnit.kontrolBolgesi = unit.kontrolBolgesi;
      markerUnit.istikamet = unit.istikamet;
      markerUnit.hiz = unit.hiz;
      markerUnit.algiDurumu = unit.algiDurumu;
      markerUnit.kisaIsim = unit.kisaIsim;
      markerUnit.taraf = unit.taraf;
      markerUnit.etmenTuru = unit.etmenTuru;
      markerUnit.faaliyeti = unit.faaliyeti;
      markerUnit.hacim = unit.hacim;
      markerUnit.insanZayiatOrani = unit.insanZayiatOrani;
      markerUnit.otonomZayiatOrani = unit.otonomZayiatOrani;
      markerUnit.etmenAktiflikDurumu = unit.etmenAktiflikDurumu;
      markerUnit.navalcraftsStatus = unit.navalcraftsStatus;
      markerUnit.aircraftsStatus = unit.aircraftsStatus;
      markerUnit.systemStatus = unit.systemStatus;

      if (this.unitToFollow && this.unitToFollow === markerUnit.id) {
        this.map.setView(unit.konum);
      }

      if (isWeaponRangeSelected !== undefined) {
        if (this.rangeDonutCollection && this.rangeDonutCollection.length > 0) {
          const filteredCollections = this.rangeDonutCollection.filter((o) => o.unitId === markerUnit.id);
          if (filteredCollections && filteredCollections.length > 0)
            filteredCollections.forEach((rangeLayer) => {
              if (rangeLayer) {
                rangeLayer.layer.setLatLng(unit.konum);
                rangeLayer.layer.redraw();
              }
            });
        }
      }

      if (isSenseRangeSelected !== undefined) {
        const { innerCircle, konikler } = this.senseSectorCollection[markerUnit.id];

        if (konikler.length > 0) {
          konikler.forEach((konik) => {
            konik.update({
              location: [unit.konum.lat, unit.konum.lng],
              direction: unit.istikamet,
            });
          });

          // senseLayer.setLatLng(unit.konum);
          // senseLayer.redraw();
        }

        if (innerCircle) {
          innerCircle.setLatLng([unit.konum.lat, unit.konum.lng]);
        }
      }

      if (isVolumeSitrepSelected !== undefined) {
        const volumeRectangle = this.volumeRectangleCollection[markerUnit.id];

        if (volumeRectangle) {
          this.setVolumeRectangle(
            volumeRectangle,
            markerUnit.konum,
            markerUnit.istikamet,
            markerUnit.hacim.genislik,
            markerUnit.hacim.uzunluk,
          );
          volumeRectangle.redraw();
        }
      }

      if (shouldKonumUpdate) {
        marker.setLatLng(unit.konum);
      }

      if (shouldRotaBolgemiUpdate) {
        markerUnit.rotaBolgeMi = unit.rotaBolgeMi;
      }

      if (shouldIconUpdate) {
        const icon = await unitIconGenerator(markerUnit, {
          additionalInfoBool: this.map.getZoom() > displayAdditionalInfoThreshold,
          relation: this.sideRelations?.find(
            (o) => o.tarafKaynakId === this.ownTarafId && o.tarafHedefId === unit.taraf?.id,
          )?.deger,
          ignoreRelation: true,
          mapVisualSettings: this.mapVisualSettings,
        });

        if (icon) {
          marker.setIcon(icon);
        }
      }

      this.markers[id] = {
        ...this.markers[id],
        unit: markerUnit,
      };
    }

    if (unit?.isActive && isUnitDetected(unit?.algiDurumu) && isUnitAllowed) {
      this.unitMarkersGroupAddHandler(marker, unit, markerDisplayMethod);
    }

    const isPassive = unit.etmenAktiflikDurumu === EtmenDurumu.PASIF;

    if (unit.algiDurumu === EAlgiDurumu['Not Detected or Identified'] || isPassive) {
      if (this.unitMarkersGroup.hasLayer(marker)) {
        this.unitRemoveHandler(marker, unit, markerDisplayMethod);
      }
    }

    if (unit.rota && unit.rota.length > 1 && this.sitrepSelectedUnits.some((o) => o === id)) {
      this.toggleRoutes(id, true);
    } else {
      this.toggleRoutes(id, false);
    }
    const faaliyetDurumuBeklemedeMi = unit.faaliyeti === EFaaliyet.BEKLEMEDE;
    const harekatSafhasiYakitIkmalMi =
      unit.harekatSafhasi === ESubFaaliyet['AIR WAITING FUEL SUPPLY'] ||
      unit.harekatSafhasi === ESubFaaliyet['AIR AWACS EXECUTION'];

    const isAddCircleToBreakPoints = faaliyetDurumuBeklemedeMi || harekatSafhasiYakitIkmalMi;

    const foundKonum = unit.rota && unit.rota.find((o) => o.siralama === unit.rotaSirasi + 1);

    if (unit.rota && unit.rotaBolgeMi) {
      const location0 = unit.rota[0];
      const location1 = unit.rota[1];

      if (location0 && location1) {
        const northEastLocation = new LatLng(location1?.konum?.lat, location0?.konum?.lng);
        const southWestLocation = new LatLng(location0?.konum?.lat, location1?.konum?.lng);

        const reconAreaBounds = new L.LatLngBounds(southWestLocation, northEastLocation);

        const patrolZoneLayers = patrolReconZone.getLayers() as L.Rectangle[];
        const foundLayer = patrolZoneLayers.find((u) => u.options.unitId === id);

        if (!foundLayer) {
          const rectangle = new L.Rectangle(
            [
              [0, 0],
              [0, 0],
            ],
            {
              // @ts-ignore
              unitId: id,
            },
          );
          rectangle.setBounds(reconAreaBounds);
          patrolReconZone.addLayer(rectangle);
          patrolReconZone.getLayers().forEach((layer) => {
            if (layer instanceof L.Rectangle) {
              layer.redraw();
            }
          });
        } else {
          foundLayer.setBounds(reconAreaBounds);
        }

        this.unitRoutesGroup.removeLayer(previousRoute);
        this.unitRoutesGroup.removeLayer(remainingRoute);
      }
    } else {
      this.unitRoutesGroup.removeLayer(patrolReconZone);
      patrolReconZone = L.featureGroup();
    }

    // Update Prev Route
    if (previousRoute && !unit.rotaBolgeMi) {
      if (unit.rota && unit.rota.length > 1) {
        if (isAddCircleToBreakPoints) {
          const circle = new L.Circle([0, 0], {
            radius: 0,
            color: unit.taraf?.rengi,
            opacity: 0.8,
            fillColor: unit.taraf?.rengi,
            unitId: id,
          });
          if (this.havaEtmeniBeklemeAlaniYaricapi) circle.setRadius(this.havaEtmeniBeklemeAlaniYaricapi);
          circle.setLatLng([foundKonum?.konum.lat || unit.konum.lat, foundKonum?.konum.lng || unit.konum.lng]);
          const circleLayers = unitStandbyArea.getLayers() as L.Circle[];
          const isLayerExist = circleLayers.find((o) => o.options.unitId === id);
          if (!isLayerExist) unitStandbyArea.addLayer(circle);
        } else if (unitStandbyArea) {
          this.unitRoutesGroup.removeLayer(unitStandbyArea);
          unitStandbyArea = L.featureGroup();
        }

        const locationForReconZone = unit.rota && unit.rota.filter((o) => o.havaKesifBolgesiMi);
        try {
          if (locationForReconZone && locationForReconZone.length > 1 && unit.etmenTipi === EEtmenTipi.HAVA) {
            const reconZoneIndexes = Math.floor(locationForReconZone.length / 4);

            for (let i = 0; i < reconZoneIndexes; i += 1) {
              const reconZoneLayer = createOrGetZone(reconnaisanceZones, `zone${i}`);
              //  const northEastIndexConvertion = reconZoneIndexes % 2 === 0 ? 2 : 3;

              const location0 = locationForReconZone[i * 4];

              const extractedKonumArray = locationForReconZone.slice(i * 4, i * 4 + 4);

              const location1 = this.findMaxDistanceGenerator(
                extractedKonumArray.map((o) => o.konum),
                location0.konum,
              );

              if (location0 && location1) {
                const northEastLocation = new LatLng(location1?.lat, location0?.konum?.lng);
                const southWestLocation = new LatLng(location0?.konum?.lat, location1?.lng);

                const reconAreaBounds = new L.LatLngBounds(southWestLocation, northEastLocation);

                reconZoneLayer.setBounds(reconAreaBounds);
              }
            }
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Failed to set recon zone error:', error);
        }

        let prevPoints: number[][] | number[][][] = [];

        if (locationForReconZone && locationForReconZone.length > 0 && unit.etmenTipi === EEtmenTipi.HAVA) {
          const polylineArray = [];
          let firstIndex = 0;
          for (let i = 0; i < locationForReconZone.length / 4; i += 1) {
            const currentIndex = firstIndex;

            polylineArray.push(
              unit.rota.filter((o) => o.siralama >= currentIndex && o.siralama <= locationForReconZone[i * 4].siralama),
            );

            if (i === locationForReconZone.length / 4 - 1) {
              polylineArray.push(
                unit.rota.filter(
                  (o) => o.siralama >= currentIndex && o.siralama >= locationForReconZone[i * 4 + 3].siralama,
                ),
              );
            }

            firstIndex = locationForReconZone[i * 4 + 3].siralama;
          }
          const updatedPolylineArray = polylineArray.map((o) => {
            const updatedPolyine = [
              ...o.filter((u) => u.siralama <= unit.rotaSirasi).map((t) => [t.konum.lat, t.konum.lng]),
            ];

            if (unit.rotaSirasi >= o[0].siralama && unit.rotaSirasi < o[o.length - 1].siralama) {
              updatedPolyine.push([unit.konum.lat, unit.konum.lng]);
            }

            return updatedPolyine;
          });

          prevPoints = updatedPolylineArray;
        } else {
          const foundLayer = (unitStandbyArea.getLayers() as L.Circle[]).find((o) => o.options.unitId === id);
          prevPoints = [
            ...unit.rota.filter((o) => o.siralama <= unit.rotaSirasi).map((o) => [o.konum.lat, o.konum.lng]),
            ...[
              isAddCircleToBreakPoints
                ? foundLayer
                  ? [foundLayer?.getLatLng()?.lat, foundLayer?.getLatLng()?.lng]
                  : [unit.konum.lat, unit.konum.lng]
                : [unit.konum.lat, unit.konum.lng],
            ],
          ];
        }

        previousRoute.setLatLngs(prevPoints as LatLngTuple[]);
        previousRoute.redraw();
        if (unit.etmenTipi === EEtmenTipi.HAVA) {
          unitStandbyArea.getLayers().forEach((layer) => {
            if (layer instanceof L.Circle) {
              layer.redraw();
            }
          });
          reconnaisanceZones.eachLayer((layer) => {
            if (layer instanceof L.Rectangle) {
              layer.redraw();
            }
          });
        }
      } else {
        this.unitRoutesGroup.removeLayer(previousRoute);
        this.unitRoutesGroup.removeLayer(unitStandbyArea);

        previousRoute = getDefaultPrevRoute(unit.taraf?.rengi);
        unitStandbyArea = L.featureGroup();
        this.unitRoutesGroup.removeLayer(reconnaisanceZones);
        reconnaisanceZones = L.featureGroup();
      }
    }

    // Update Rema Route
    if (remainingRoute && !unit.rotaBolgeMi) {
      if (unit.rota && unit.rota.length > 1) {
        if (isAddCircleToBreakPoints) {
          const circle = new L.Circle([0, 0], {
            radius: 0,
            color: unit.taraf?.rengi,
            opacity: 0.8,
            fillColor: unit.taraf?.rengi,
            unitId: id,
          });
          if (this.havaEtmeniBeklemeAlaniYaricapi) circle.setRadius(this.havaEtmeniBeklemeAlaniYaricapi);
          circle.setLatLng([foundKonum?.konum.lat || unit.konum.lat, foundKonum?.konum.lng || unit.konum.lng]);
          const circleLayers = unitStandbyArea.getLayers() as L.Circle[];
          const isLayerExist = circleLayers.find((o) => o.options.unitId === id);
          if (!isLayerExist) unitStandbyArea.addLayer(circle);
        }

        const locationForReconZone = unit.rota.filter((o) => o.havaKesifBolgesiMi);

        try {
          if (locationForReconZone.length > 1 && unit.etmenTipi === EEtmenTipi.HAVA) {
            const reconZoneIndexes = Math.floor(locationForReconZone.length / 4);

            for (let i = 0; i < reconZoneIndexes; i += 1) {
              const reconZoneLayer = createOrGetZone(reconnaisanceZones, `zone${i}`);
              //  const northEastIndexConvertion = reconZoneIndexes % 2 === 0 ? 2 : 3;

              const location0 = locationForReconZone[i * 4];

              const extractedKonumArray = locationForReconZone.slice(i * 4, i * 4 + 4);

              const location1 = this.findMaxDistanceGenerator(
                extractedKonumArray.map((o) => o.konum),
                location0.konum,
              );

              if (location0 && location1) {
                const northEastLocation = new LatLng(location1?.lat, location0?.konum?.lng);
                const southWestLocation = new LatLng(location0?.konum?.lat, location1?.lng);

                const reconAreaBounds = new L.LatLngBounds(southWestLocation, northEastLocation);

                reconZoneLayer.setBounds(reconAreaBounds);
              }
            }
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Failed to set recon zone error:', error);
        }

        let remaPoints: number[][] | number[][][] = [];

        if (locationForReconZone && locationForReconZone.length > 0 && unit.etmenTipi === EEtmenTipi.HAVA) {
          const polylineArray = [];
          let firstIndex = 0;
          for (let i = 0; i < locationForReconZone.length / 4; i += 1) {
            const currentIndex = firstIndex;

            polylineArray.push(
              unit.rota.filter((o) => o.siralama >= currentIndex && o.siralama <= locationForReconZone[i * 4].siralama),
            );

            if (i === locationForReconZone.length / 4 - 1) {
              polylineArray.push(
                unit.rota.filter(
                  (o) => o.siralama >= currentIndex && o.siralama >= locationForReconZone[i * 4 + 3].siralama,
                ),
              );
            }

            firstIndex = locationForReconZone[i * 4 + 3].siralama;
          }

          const updatedPolylineArray = polylineArray.map((o) => {
            const updatedPolyine = [
              ...o.filter((u) => u.siralama > unit.rotaSirasi).map((t) => [t.konum.lat, t.konum.lng]),
            ];

            if (unit.rotaSirasi >= o[0].siralama && unit.rotaSirasi <= o[o.length - 1].siralama) {
              updatedPolyine.unshift([unit.konum.lat, unit.konum.lng]);
              return updatedPolyine;
            }

            const filteredPolylines = o
              .filter((u) => u.siralama >= unit.rotaSirasi)
              .map((t) => [t.konum.lat, t.konum.lng]);
            return filteredPolylines;
          });

          remaPoints = updatedPolylineArray;
        } else {
          const foundLayer = (unitStandbyArea.getLayers() as L.Circle[]).find((o) => o.options.unitId === id);

          remaPoints = [
            ...[
              isAddCircleToBreakPoints
                ? foundLayer
                  ? [foundLayer?.getLatLng()?.lat, foundLayer?.getLatLng()?.lng]
                  : [unit.konum.lat, unit.konum.lng]
                : [unit.konum.lat, unit.konum.lng],
            ],
            ...unit.rota.filter((o) => o.siralama > unit.rotaSirasi).map((o) => [o.konum.lat, o.konum.lng]),
          ];
        }

        remainingRoute.setLatLngs(remaPoints as LatLngTuple[]);
        remainingRoute.redraw();
        if (unit.etmenTipi === EEtmenTipi.HAVA) {
          unitStandbyArea.getLayers().forEach((layer) => {
            if (layer instanceof L.Circle) layer.redraw();
          });
          reconnaisanceZones.eachLayer((layer) => {
            if (layer instanceof L.Rectangle) {
              layer.redraw();
            }
          });
        }
      } else {
        this.unitRoutesGroup.removeLayer(remainingRoute);
        if (unitStandbyArea) this.unitRoutesGroup.removeLayer(unitStandbyArea);
        unitStandbyArea = L.featureGroup();
        remainingRoute = getDefaultRemaRoute();
        this.unitRoutesGroup.removeLayer(reconnaisanceZones);
        reconnaisanceZones = L.featureGroup();
      }
    }
    if (unit.kontrolBolgesi && unit?.kontrolBolgesi.length > 0) {
      const locations: LatLngTuple[] = unit.kontrolBolgesi.map((o) => {
        return [o.lat, o.lng];
      });

      const controlZoneLayers = capControlZone.getLayers() as L.Polygon[];
      const foundLayer = controlZoneLayers.find((u) => u.options.unitId === id);

      if (!foundLayer) {
        const controlZonePolygon = L.polygon(locations, {
          color: unit.taraf?.rengi || 'lightblue',
          fillColor: unit.taraf?.rengi || 'lightblue',
          fillOpacity: 0.2,
          unitId: id,
        });

        capControlZone.addLayer(controlZonePolygon);

        capControlZone.getLayers().forEach((layer) => {
          if (layer instanceof L.Polygon) {
            layer.redraw();
          }
        });
      } else {
        foundLayer.setLatLngs(locations);
      }

      this.unitRoutesGroup.removeLayer(previousRoute);
      this.unitRoutesGroup.removeLayer(remainingRoute);
    } else {
      this.unitRoutesGroup.removeLayer(capControlZone);
      capControlZone = L.featureGroup();
    }
  };

  removeVisualsOfUnit = (id: number) => {
    const { marker, previousRoute, remainingRoute } = this.markers[id];

    this.unitMarkersGroup.removeLayer(marker);
    this.unitRoutesGroup.removeLayer(previousRoute);
    this.unitRoutesGroup.removeLayer(remainingRoute);
  };

  filterMarkers = (filterOptions: TFilterType[]) => {
    if (filterOptions.length === 0) {
      Object.values(this.markers).forEach(({ marker }) => {
        if (!this.unitMarkersGroup.hasLayer(marker)) {
          this.unitMarkersGroup.addLayer(marker);
        }
      });
    } else {
      const activeSides = filterOptions.filter((o) => o.type === 'SIDE').map((o) => o.filteredValue);
      const activeFactions = filterOptions.filter((o) => o.type === 'FACTION').map((o) => o.filteredValue);
      const activePrototypes = filterOptions.filter((o) => o.type === 'PROTOTYPE').map((o) => o.filteredValue);

      this.units
        // .filter((o) => o.algiDurumu > 0)
        .forEach((unit) => {
          if (unit.taraf && !activeSides.includes(unit.taraf.id || 0)) {
            this.removeVisualsOfUnit(unit.id);
          }

          if (unit.etmenSinifi && !activeFactions.includes(unit.etmenSinifi.id || 0)) {
            this.removeVisualsOfUnit(unit.id);
          }

          if (unit.etmenTuru && !activePrototypes.includes(unit.etmenTuru.id || 0)) {
            this.removeVisualsOfUnit(unit.id);
          }

          if (unit.etmenTuru && activePrototypes.includes(unit.etmenTuru.id || 0)) {
            if (!this.unitMarkersGroup.hasLayer(this.markers[unit.id].marker)) {
              this.unitMarkersGroup.addLayer(this.markers[unit.id].marker);
            }
          }
        });
    }
  };

  // bindContextMenu = (marker: L.Marker, unit: MapUnit, isBind: boolean = true) => {
  //   if (
  //     this.mapViewState === MapViewState.Default &&
  //     unit.eklentiId === 0 &&
  //     !prototypeIsObstacle(unit.etmenTuru?.sembolu || 0)
  //   ) {
  //     let contextmenuItems = getContextMenuItems(
  //       isBind,
  //       unit,
  //       this.actions,
  //       this.ports,
  //       marker.getLatLng(),
  //       this.userRole,
  //       this.onClickFollowUnit,
  //       this.unitToFollow,
  //       this.activeCommands.some((command) => command.etmenId === unit.id),
  //     );

  //     // if (this.userRole !== 'Controller') {
  //     //   contextmenuItems = contextmenuItems.filter((o) => o.text !== 'Magic Fill Up Agent');
  //     // }

  //     marker.bindContextMenu({
  //       contextmenu: this.mapViewState === MapViewState.Default,
  //       contextmenuInheritItems: false,
  //       contextmenuItems,
  //     });
  //   }
  // };

  disableMarkersLeftClick() {
    this.markersLeftClickStatus = false;
    this.unitMarkersGroup.off('click');
  }

  enableMarkersLeftClick() {
    this.markersLeftClickStatus = true;
    this.bindMarkersLeftClick();
  }

  bindMarkersLeftClick() {
    this.unitMarkersGroup.off('click');
    this.unitMarkersGroup.on('click', (event: L.LeafletMouseEvent) => {
      if (this.mapViewState === MapViewState.Default || this.mapViewState === MapViewState.AAR) {
        const marker = event.propagatedFrom as L.Marker;
        const unitId = marker.options?.unitId;
        const unitType = marker.options?.unitType;

        if (unitId) {
          const overlappedUnits = this.isUnitOverlap(unitId);
          if (overlappedUnits.length > 1) {
            const localMarkers: OverlappedMarker[] = [];
            overlappedUnits.forEach(async (o) => {
              const icon = await unitIconGenerator(o, {
                additionalInfoBool: false,
                isForOverlappedPopup: true,
              });

              if (icon !== null) {
                localMarkers.push({ id: o.id, unit: o, marker: this.markers[o.id].marker, icon, unitType });
              }
            });
            if (this.overlappedUnitsPopup) {
              this.overlappedUnitsPopup({ markers: localMarkers, mouseEvent: event as L.LeafletMouseEvent });
            }
          } else {
            this.actions?.onMapUnitClicked(unitId, unitType);
          }
        }
      }
    });
  }

  setOverlappedUnitsPopup = (overlappedUnitsPopup: (options: OverlappedUnitsPopupArgs) => void) => {
    this.overlappedUnitsPopup = overlappedUnitsPopup;
  };

  isUnitAllowedThroughFilter = (unit: MapUnit) => {
    const isSideAllowed =
      this.activeFilters.sides.length > 0
        ? unit.taraf && this.activeFilters.sides.includes(unit?.taraf?.id || 0)
        : true;

    const isFactionAllowed =
      this.activeFilters.factions.length > 0
        ? unit.etmenSinifi && this.activeFilters.factions.includes(unit.etmenSinifi.id || 0)
        : true;

    const isPrototypeAllowed =
      this.activeFilters.prototypes.length > 0
        ? unit.etmenTuru && this.activeFilters.prototypes.includes(unit.etmenTuru.id || 0)
        : true;

    return isSideAllowed && isFactionAllowed && isPrototypeAllowed;
  };
}
